import React from 'react';
import { FileText, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export function StatuteExcerpt() {
  return (
    <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
      <div className="flex items-center gap-4 mb-6">
        <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
          <FileText className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
        </div>
        <h2 className="card-title">
          Statut Fundacji
        </h2>
      </div>
      
      <div className="space-y-6">
        <div className="prose prose-gray dark:prose-invert">
          <p className="body-medium">
            Fundacja „ZNAJDKI" działa na podstawie Ustawy o fundacjach oraz ustawy o działalności pożytku publicznego i wolontariacie. Naszym głównym celem jest ochrona zwierząt udomowionych i dziko żyjących oraz ochrona dziedzictwa przyrodniczego.
          </p>
        </div>

        <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
          <h3 className="heading-5 mb-4">
            Główne cele statutowe:
          </h3>
          <ul className="space-y-2 body-medium">
            <li className="list-item">
              <span className="text-accessible-red-600">•</span>
              Zapobieganie i zwalczanie bezdomności zwierząt
            </li>
            <li className="list-item">
              <span className="text-accessible-red-600">•</span>
              Przeciwdziałanie przemocy wobec zwierząt
            </li>
            <li className="list-item">
              <span className="text-accessible-red-600">•</span>
              Pomoc zwierzętom krzywdzonym i porzuconym
            </li>
          </ul>
        </div>

        <Link
          to="/statut"
          className="inline-flex items-center gap-2 link-primary group"
        >
          <span>Zobacz pełny statut fundacji</span>
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" aria-hidden="true" />
        </Link>
      </div>
    </div>
  );
}